import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { callApi, GATEWAYS } from '../../../utils';
import { showError } from '../../../actions/notificationActions';

function ShiftEnquries({ serviceCode = '', dispatch }) {
  const [formData, setFormData] = useState({});
  const [selectedGateway, setSelectedGateway] = useState('');
  const [reportMetadata, setReportMetadata] = useState(null);
  const [isExporting, setIsExporting] = useState(false);

  function handleInputChange(evt) {
    const { name, value } = evt.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  function handleGatewaySelect(evt) {
    setSelectedGateway(evt.target.value);
  }

  async function handleExportClick() {
    setIsExporting(true);

    if (reportMetadata) {
      downloadFileFromLink(
        reportMetadata.download_url,
        reportMetadata.filename
      );

      return setIsExporting(true);
    }

    callApi(`provider/${serviceCode}/transactions/metadata`, {
      gateway: selectedGateway,
      ...formData,
    })
      .then((result) => {
        const data = result.data;
        setReportMetadata(data);

        downloadFileFromLink(data.download_url, data.filename);
      })
      .catch((err) => {
        dispatch(
          showError(
            'report cannot be downloaded at this time, please try again later',
            err.message
          )
        );
      })
      .finally(() => {
        setIsExporting(false);
      });
  }

  function downloadFileFromLink(link, fileName = 'export.csv') {
    const anchorElement = document.createElement('a');
    anchorElement.setAttribute('href', link);
    anchorElement.setAttribute('download', true);
    anchorElement.setAttribute('filename', fileName);
    document.body.appendChild(anchorElement);
    anchorElement.click();
    return anchorElement.remove();
  }

  const supportedGateways = [
    { value: '', name: 'Please select a Gateway' },
    ...(GATEWAYS[serviceCode] || []),
  ];

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <div>
          <div>
            <label>Select Gateway: </label>
            <select onChange={handleGatewaySelect}>
              {supportedGateways.map((gateway, index) => {
                return (
                  <option key={index} value={gateway.value}>
                    {gateway.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div style={{ display: 'flex', alignContent: 'center' }}>
            <label>
              Select Transaction Day:
              <input
                name="paymentDate"
                value={formData.paymentDate || ''}
                onChange={handleInputChange}
                required={true}
                type="date"
              />
            </label>
          </div>
        </div>

        <div></div>
      </div>

      <div>
        <Button
          color="success"
          disabled={
            isExporting || !selectedGateway || !Object.keys(formData).length
          }
          onClick={handleExportClick}
        >
          Export to CSV
          {isExporting ? (
            <span
              className="fas fa-spinner fa-spin"
              style={{ marginInlineStart: '5px' }}
            ></span>
          ) : (
            ''
          )}
        </Button>
      </div>
    </div>
  );
}

export default connect()(ShiftEnquries);
